module.exports = __webpack_public_path__ + "img/ec1.72c25775.png";